import { render, staticRenderFns } from "./slider-item-fyroro.vue?vue&type=template&id=2fa25f25&scoped=true&"
import script from "./slider-item-fyroro.vue?vue&type=script&lang=js&"
export * from "./slider-item-fyroro.vue?vue&type=script&lang=js&"
import style0 from "./slider-item-fyroro.vue?vue&type=style&index=0&id=2fa25f25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa25f25",
  null
  
)

export default component.exports